module.exports = __webpack_public_path__ + "assets/img/img_2001.7a7e8be1.jpg";